export interface AdjacencyParams {
  pageIndex: number;
  totalCount: number;
  pageSize: number;
}

export const getAdjacentPages = ({ pageIndex, totalCount, pageSize }: AdjacencyParams) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  // If there are no more than 6 pages, it does not matter which index is selected
  // the number of pages will depend on the total pages
  if (totalPages <= 6) {
    return _getAdjacentPages({ startPage: 0, endPage: totalPages - 1, pageIndex });
  }

  let startPage = pageIndex - 2;
  let endPage = pageIndex + 3;

  if (startPage < 0) {
    endPage -= startPage;
    startPage = 0;
  }

  if (endPage >= totalPages) {
    endPage = totalPages - 1;
    if (endPage > 4) {
      startPage = endPage - 4;
    } else if (totalPages <= 4) {
      startPage = 0;
    }
  }

  return _getAdjacentPagesWithMoreOption({ startPage, endPage, pageIndex, totalPages });
};

const _getAdjacentPagesWithMoreOption = ({ startPage, endPage, pageIndex, totalPages }) => {
  const pages = [];
  if (pageIndex < totalPages / 2) {
    _generatePages(pages, { startPage, endPage: endPage - 1, pageIndex });

    if (endPage <= totalPages - 1) {
      pages.push({ label: '...', value: '+2' });
    }
  } else {
    if (startPage >= 0) {
      pages.unshift({ label: '...', value: '-2' });
    }
    _generatePages(pages, { startPage, endPage, pageIndex });
  }

  return pages;
};

const _getAdjacentPages = ({ startPage, endPage, pageIndex }) => {
  const pages = [];
  _generatePages(pages, { startPage, endPage, pageIndex });

  return pages;
};

const _generatePages = (pages, { startPage, endPage, pageIndex }) => {
  for (let i = startPage; i <= endPage; i++) {
    pages.push({ label: `${i + 1}`, value: i.toString(), current: i === pageIndex });
  }
};
